import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-front-page",
  templateUrl: "./front-page.component.html",
  styleUrls: ["./front-page.component.scss"]
})
export class FrontPageComponent implements OnInit {
  today = new Date();
  christmasDate = new Date(this.today.getFullYear(), 11, 24); //11 because date starts at 0
  birthdayDate = new Date(this.today.getFullYear(), 7, 29); //7 because date starts at 0

  constructor() {}

  ngOnInit() {
    if (this.christmasDate < this.today) {
      this.christmasDate.setFullYear(this.today.getFullYear() + 1);
      this.birthdayDate.setFullYear(this.today.getFullYear() + 1);
    }
  }

  isClosingInOnBirthday() {
    return this.today.valueOf() < this.birthdayDate.valueOf();
  }

  daysUntil(date: Date) {
    var timeDiff = date.getTime() - this.today.getTime();

    var dayDiff = timeDiff / (1000 * 3600 * 24);

    return Math.round(dayDiff);
  }
}
